export default "__VITE_ASSET__BF258lMz__"